export const NAMESPACE = 'contacts'
